import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

/** The login popup (outside Teams) returns to this same page with the Entra response in the URL. */
function isAuthResponse(): boolean {
  return [location.hash.slice(1), location.search.slice(1)].some((part) => {
    const params = new URLSearchParams(part);
    return params.has("state") && (params.has("code") || params.has("error"));
  });
}

if (isAuthResponse()) {
  // MSAL 5 doesn't read the popup's URL from the main window: the popup page has to relay the
  // response, and then it closes. The app itself is not rendered inside the popup.
  import("@azure/msal-browser/redirect-bridge")
    .then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
    .catch((err) => console.error("Could not complete the login", err));
} else {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
